<!-- Content -->
@if (slideAuthorFacade.currentSelectedSlideAnnotation$ | async; as annotation) {
  <div
    class="flex flex-column align-items-center">
    <!-- Images -->
    @if (slideAuthorFacade.imageIdsByAnnotation$(annotation.id) | async; as imageIds) {
      <medsurf-design-input-multi-select
        [name]="'annotation_images'"
        [label]="'global.images'"
        [model]="imageIds"
        [options]="(slideAuthorFacade.currentSelectedSlideImagesArray$(translate, imageIds) | async) || []"
        [optionDisabled]="'inactive'"
        [showToggleAll]="true"
        [group]="true"
        [class]="'w-full'"
        [labelIcon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.IMAGE"
      (valueChange)="onChange($event)"></medsurf-design-input-multi-select>
    }
  </div>
}
